/* eslint-disable no-console */
/* eslint-disable no-undef */
/* eslint-disable no-underscore-dangle */
class GiftProductModal extends HTMLElement {
  constructor() {
    super();
    this.modal = this;
    this.overlay = this.querySelector('.gift-modal__overlay');
    this.closeButton = this.querySelector('.gift-modal__close');
    this.colorSelector = this.querySelector('.color-selector');
    this.variantsContainer = this.querySelector('.variant-selector__variants');
    this.confirmButton = this.querySelector('.confirm-gift-button');
    this.variantImage = this.querySelector('[data-variant-image]');
    this.productTitle = this.querySelector('[data-product-title]');
    this.variantName = this.querySelector('[data-variant-name]');
    this.colorDot = this.querySelector('[data-color-dot]');
    this.originalPrice = this.querySelector('[data-original-price]');
    this.marketThresholdElement = document.querySelector(
      '[data-market-threshold]'
    );

    this.init();
  }

  init() {
    this.overlay?.addEventListener('click', () => this.close());
    this.closeButton?.addEventListener('click', () => this.close());

    this.colorSelector?.addEventListener('click', (e) => {
      e.stopPropagation();
      this.variantsContainer?.classList.toggle('active');
    });

    document.addEventListener('click', (e) => {
      if (!this.contains(e.target)) {
        this.variantsContainer?.classList.remove('active');
      }
    });

    if (this.variantsContainer) {
      this.variantsContainer.addEventListener('click', (e) => {
        const variantButton = e.target.closest('.variant-option');
        if (variantButton && !variantButton.disabled) {
          this.selectVariant(variantButton);
        }
      });
    }

    this.confirmButton?.addEventListener('click', () => this.addGiftToCart());

    document.addEventListener('click', (e) => {
      const giftButton = e.target.closest('.select-gift-button');
      if (!giftButton) {
        return;
      }
      const { directAdd, variantId } = giftButton.dataset;
      if (directAdd === 'true' && variantId) {
        this.addGiftToCart(giftButton);
      } else {
        this.open();
      }
    });
  }

  open() {
    this.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  close() {
    this.classList.remove('active');
    document.body.style.overflow = '';
    this.variantsContainer?.classList.remove('active');
  }

  selectVariant(button) {
    const { variantId } = button.dataset;
    const { productTitle } = button.dataset;
    const { variantTitle } = button.dataset;
    const { decorName } = button.dataset;
    const { decorImage } = button.dataset;
    const { variantImage } = button.dataset;
    const { variantPrice } = button.dataset;

    if (this.variantImage && variantImage) {
      this.variantImage.src = variantImage;
    }

    if (this.productTitle && productTitle) {
      this.productTitle.textContent = productTitle;
    }

    if (this.variantName) {
      const newName = decorName || productTitle || variantTitle;
      this.variantName.textContent = newName;
    }

    // Update color-dot image (like bundle does);
    // hide it for entries without a decor swatch
    if (this.colorDot) {
      if (decorImage) {
        // If it's already an img element
        if (this.colorDot.tagName === 'IMG') {
          this.colorDot.src = decorImage;
          this.colorDot.alt = decorName || '';
          this.colorDot.hidden = false;
        } else {
          // If it's a span, replace with img
          const img = document.createElement('img');
          img.className = 'color-dot';
          img.src = decorImage;
          img.alt = decorName || '';
          img.dataset.colorDot = '';
          this.colorDot.parentNode.replaceChild(img, this.colorDot);
          this.colorDot = img;
        }
      } else {
        this.colorDot.hidden = true;
      }
    }

    if (this.originalPrice && variantPrice) {
      const priceInCents = parseInt(variantPrice, 10);
      const priceFormatted = new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR',
      }).format(priceInCents / 100);
      this.originalPrice.textContent = priceFormatted;
    }

    if (this.confirmButton) {
      this.confirmButton.dataset.currentVariantId = variantId;
    }

    this.variantsContainer?.classList.remove('active');
  }

  async addGiftToCart(triggerButton) {
    const isDirectAdd = Boolean(triggerButton);
    const button = triggerButton || this.confirmButton;
    const variantId = isDirectAdd
      ? triggerButton.dataset.variantId
      : this.confirmButton?.dataset.currentVariantId ||
        this.querySelector('[data-single-variant-id]')?.dataset.singleVariantId;

    if (!button || !variantId) {
      return;
    }

    const labelElement =
      (isDirectAdd && button.querySelector('.select-gift-button-text')) ||
      button;
    const originalText = labelElement.textContent;

    button.disabled = true;
    labelElement.textContent = button.dataset.addingText || 'Adding...';

    try {
      const cartData = await fetch(`${window.Shopify.routes.root}cart.js`).then((res) => res.json());

      const giftAlreadyInCart = cartData.items.some(
        (item) => item.properties && item.properties._gift_product === 'true'
      );

      if (giftAlreadyInCart) {
        if (!isDirectAdd) {
          this.close();
        }
        return;
      }

      const cartDrawer = document.querySelector('cart-drawer-items');
      const sections = cartDrawer
        ? cartDrawer.getSectionsToRender().map((section) => section.section)
        : [];

      const formData = {
        items: [
          {
            id: variantId,
            quantity: 1,
            properties: {
              _gift_product: 'true',
              _market_threshold: `${this.marketThresholdElement.attributes['data-market-threshold'].value}`,
            },
          },
        ],
        sections,
        sections_url: window.location.pathname,
      };

      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to add gift to cart: ${errorText}`);
      }

      const parsedState = await response.json();

      if (
        typeof publish !== 'undefined' &&
        typeof PUB_SUB_EVENTS !== 'undefined'
      ) {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'gift-modal',
          cartData: parsedState,
        });
      }

      // cart-delivery-tagging only re-processes the cart when it hears this
      // event (cart.js dispatches it after quantity updates). Without it the
      // delivery date shown in the drawer stays stale after a gift is added
      // until the next cart change or a full page reload.
      document.dispatchEvent(
        new CustomEvent('delivery-dates:calculated', {
          detail: { datesUpdated: false },
        })
      );

      if (!isDirectAdd) {
        this.close();
      }
    } catch (error) {
      console.error('Error adding gift to cart:', error);
      if (isDirectAdd) {
        this.showGiftError();
      }
    } finally {
      button.disabled = false;
      labelElement.textContent = isDirectAdd
        ? originalText
        : button.dataset.originalText || 'IN DEN WARENKORB';
    }
  }

  showGiftError() {
    const template = this.querySelector('[data-gift-error-template]');
    const container = document.getElementById('gift-removal-error-container');

    if (!template || !container) {
      return;
    }

    const cheeringMsg = document.getElementById('cheering-msg-container');
    if (cheeringMsg) {
      cheeringMsg.style.display = 'none';
    }

    container.innerHTML = '';
    container.appendChild(template.content.cloneNode(true));
    container.style.display = 'block';
  }
}

customElements.define('gift-product-modal', GiftProductModal);
